// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__LbdCn","pulse":"styles_pulse__U9tMw","box":"styles_box__GfxsR"};